import { jsx as _jsx } from "react/jsx-runtime";
import Blocker from "../components/Blocker.js";
export default function ReloadingPage(props) {
    return (_jsx(Blocker, { className: "d-flex flex-grow-1 flex-column", blocking: props.reloading, children: props.children }));
}
